import { render } from "./LimitRow.vue?vue&type=template&id=c1459178"
import script from "./LimitRow.vue?vue&type=script&lang=js"
export * from "./LimitRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__